import { MutableTypedObject, TypedObject } from "@multiweb/types/react";

/** Typ pro uložení extendedProperties. */
export type ExtendedPropertiesType = TypedObject<string>;

/** Modifikovatelný typ pro uložení extendedProperties. */
export type MutableExtendedPropertiesType = MutableTypedObject<string>;

/** Typ pro uložení tagů. */
export type TagsType = TypedObject<boolean>;

/** Modifikovatelný typ pro uložení tagů. */
export type MutableTagsType = MutableTypedObject<boolean>;
